import { OptionModel } from '@akin-home/options';
import {
  createOptionMutation,
  optionModelToCreateMutationInput,
} from '@akin-home/options/frontend';
import { useCallback } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { options_query_keys } from './index';

export const useCreateOptionMutation = () => {
  const query_client = useQueryClient();

  return useMutation(createOptionMutation, {
    onSuccess() {
      query_client.invalidateQueries(options_query_keys.all);
    },
  });
};

export const useCreateOptionFromModel = () => {
  const create = useCreateOptionMutation();

  return useCallback(
    (option: OptionModel) =>
      create.mutateAsync({
        input: optionModelToCreateMutationInput(option),
      }),
    [create]
  );
};
